import { render, staticRenderFns } from "./position.vue?vue&type=template&id=d9f022aa&scoped=true"
import script from "./position.vue?vue&type=script&lang=js"
export * from "./position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f022aa",
  null
  
)

export default component.exports